import { PaginationLayout } from './PaginationLayout'
export default PaginationLayout
